import React, { useEffect } from 'react';
import { Flame, Users, Utensils, Sun } from 'lucide-react';
import { bbqArea } from '../data/mockData';

const Barbecue = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] overflow-hidden"
        style={{
          backgroundImage: `url(${bbqArea.images[0]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>

        <div className="absolute inset-0 bg-gradient-to-b from-wood-brown/80 to-wood-brown/60" />
        <div className="relative container mx-auto px-4 h-full flex items-center justify-center">
          <div className="text-center max-w-3xl">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-cream mb-6">
              {bbqArea.title}
            </h1>
            <p className="text-xl font-serif text-cream/90 leading-relaxed">
              Un'esperienza unica all'aria aperta per gustare le nostre carni grigliate
            </p>
          </div>
        </div>
      </section>

      {/* Description Section */}
      <section className="py-20 bg-cream">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-xl text-wood-brown font-serif leading-relaxed">
                {bbqArea.description}
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
              <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                <div className="w-16 h-16 bg-burgundy/10 rounded-full flex items-center justify-center mb-6">
                  <Flame size={32} className="text-burgundy" />
                </div>
                <h3 className="font-serif text-2xl font-bold text-burgundy mb-4">
                  Spazio all'aperto attrezzato
                </h3>
                <p className="text-wood-brown font-serif leading-relaxed">
                  La nostra area barbecue è completamente attrezzata per offrirvi il massimo comfort 
                  durante le vostre grigliate estive.
                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                <div className="w-16 h-16 bg-burgundy/10 rounded-full flex items-center justify-center mb-6">
                  <Users size={32} className="text-burgundy" />
                </div>
                <h3 className="font-serif text-2xl font-bold text-burgundy mb-4">
                  Atmosfera familiare e sociale
                </h3>
                <p className="text-wood-brown font-serif leading-relaxed">
                  Un ambiente conviviale dove trascorrere piacevoli momenti in famiglia o con amici, 
                  immersi nella tradizione romagnola.
                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                <div className="w-16 h-16 bg-burgundy/10 rounded-full flex items-center justify-center mb-6">
                  <Utensils size={32} className="text-burgundy" />
                </div>
                <h3 className="font-serif text-2xl font-bold text-burgundy mb-4">
                  Carni fresche grigliate al momento
                </h3>
                <p className="text-wood-brown font-serif leading-relaxed">Salsicce, spiedini, arrosticini e molto altro: tutte le nostre specialità da cuocere al momento per garantire freschezza e sapore.


                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                <div className="w-16 h-16 bg-burgundy/10 rounded-full flex items-center justify-center mb-6">
                  <Sun size={32} className="text-burgundy" />
                </div>
                <h3 className="font-serif text-2xl font-bold text-burgundy mb-4">Perfetto per cene in compagnia

                </h3>
                <p className="text-wood-brown font-serif leading-relaxed">
                  L'ideale per eventi, compleanni, riunioni di famiglia o semplicemente 
                  per godersi una bella serata estiva all'aria aperta.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Gallery Section */}
      <section className="py-20 bg-beige">
        <div className="container mx-auto px-4">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-burgundy text-center mb-12">
            La Nostra Area Barbecue
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src={bbqArea.images[0]}
                alt="Vista aerea area barbecue"
                className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500" />

            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src={bbqArea.images[1]}
                alt="Grigliata di salsicce e carne"
                className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500" />

            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/cpshcxqc_1000063499-01.jpeg"
                alt="Arrosticini serviti durante evento serale"
                className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500" />

            </div>
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/8tb06vr5_4.jpg"
                alt="Evento barbecue diurno con ospiti"
                className="w-full h-[400px] object-cover hover:scale-105 transition-transform duration-500" />

            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-burgundy text-cream">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6">
            Vieni a Trovarci Durante l'Estate
          </h2>
          <p className="text-lg font-serif max-w-2xl mx-auto leading-relaxed text-cream/90 mb-8">
            L'area barbecue è aperta durante i mesi estivi. 
            Contattaci per maggiori informazioni sugli orari e la disponibilità.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:0541750295"
              className="inline-flex items-center justify-center bg-cream text-burgundy px-8 py-4 rounded-md font-serif font-medium text-lg transition-all duration-300 hover:bg-beige hover:shadow-xl hover:scale-105">

              Chiamaci: 0541 750295
            </a>
            <a
              href="https://wa.me/3500098273"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-transparent border-2 border-cream text-cream px-8 py-4 rounded-md font-serif font-medium text-lg transition-all duration-300 hover:bg-cream hover:text-burgundy hover:shadow-xl hover:scale-105">WhatsApp: 3500098273


            </a>
          </div>
        </div>
      </section>
    </div>);

};

export default Barbecue;